/*
* Base JS file
*/

$(function() {
  /* Multiple currencies */
  if ($('body').hasClass('currencies')) {
    var $currencyPicker = $('.currency-picker');
    $currencyPicker.on('click', 'a', function(e) {
      $currencyPicker.find('#current-currency').hide();
      $currencyPicker.find('#currencies-picker').fadeIn();
      e.preventDefault();
      return false;
    }).on('change', 'select', function() {
      $currencyPicker.find('#current-currency').fadeIn();
      $currencyPicker.find('#currencies-picker').hide();
    }).on('blur', 'select', function(){
      $currencyPicker.find('#current-currency').fadeIn();
      $currencyPicker.find('#currencies-picker').hide();
    });
  }
});

/* Show/Hide Cart Note */
$('#cart-note').on('show.bs.collapse', function(){
  $('.cart-note-action').hide();
});
$('#cart-note').on('shown.bs.collapse', function(){
  $(this).find('#note').focus();
});

/* Notify me form */
$(document).on('submit', '.notify-me-wrapper form', function(e){
  var $self = $(this);
  $self.find('.alert').removeClass('alert-danger alert-success').text('').hide();
  
  if($self.find('[type="email"]').val() !== ''){
    $.ajax({
      url: '/contact',
      type: 'POST',
      data: $self.serialize()
    })
    .done(function(){
      $self.find('.alert').addClass('alert-success').text('Thanks! We will notify you when this product becomes available.').show();
      $self.find('.form-group').removeClass('has-error').hide();
    })
    .fail(function(a,b,c){
      console.log(a,b,c);
      $self.find('.alert').addClass('alert-danger').text('There was an error submitting your email. Please try again later.').show();
    });
  } else {
    $self.find('.alert').addClass('alert-danger').text('Please enter an email adddress.').show();
    $self.find('.form-group').addClass('has-error');
  }
  e.preventDefault();
});

/* add body classes on bootstrap js actions */
$(document).on('show.bs.collapse', '#top-nav', function(){
  $('body').removeClass('navbar-collapse-hide').addClass('navbar-collapse-show');
});
$(document).on('hidden.bs.collapse', '#top-nav', function(){
  $('body').removeClass('navbar-collapse-show').addClass('navbar-collapse-hide');
});

$(document).ready(function() {
  var store = window.store;

  $('input.searchspring-query').focus();

  $(".xselect-single").select2();
  $('.qty').on('click', function() {
    $(this).select();
  });

  $('[id^=subnav-link-]').hover(function() {
    var $subnav_img = $(this).data('img-src');
    var $category = $(this).data('category');
    var $link = $(this).children('a').attr('href');
    $('#subnav-img-' + $category).attr('src', $subnav_img);
    $('.subnav-img-link').attr('href', $link);
  });
  var tz = moment.tz.guess();
  moment.tz.setDefault('Europe/Amsterdam');
  var nowWarehouse = moment();
  console.log('Warehouse Time: ' + nowWarehouse.format());
  var nowWarehouseDay = parseInt(nowWarehouse.format('E'));
  console.log('Day at Warehouse: ' + nowWarehouseDay);
  var deadline = moment().hours('18').minutes('0').seconds('0');
  console.log('Deadline: ' + deadline.format());
  var shipdelay = 1;
  console.log('Hour at Warehouse: ' + nowWarehouse.hour());
  if (nowWarehouse.hour() >= '18') {
    console.log('Warehouse Time after same-day cutoff');
  }
  var diff = nowWarehouse.diff(deadline, 'minutes');
  console.log('Warehouse to Deadline Diff: ' + diff + ' minutes');
  var weekend = false;
  var productShipMessage = '';
  var cartShipMessage = '';
  if ((nowWarehouseDay === 5 && diff > 0) || (nowWarehouseDay > 5)) {
    weekend = true;
    shipdelay = 2;
    productShipMessage = 'Order now, ships Monday!';
    cartShipMessage = 'ships Monday!';
    console.log('Shipping: Weekend');
  }
  if (!weekend) {
    if (diff > 0) {
      shipdelay = 1;
      productShipMessage = 'Order now, ships tomorrow!';
      cartShipMessage = 'ships tomorrow!';
      console.log('Shipping: Tomorrow');
    } else {
      shipdelay = 0;
      productShipMessage = 'Order now, ships today!';
      cartShipMessage = 'ships today!';
      console.log('Shipping: Today');
    }
  }
  if (shipdelay < 1) {
    $('.countdown').countdown(deadline.tz(tz).format('YYYY/MM/DD HH:mm:ss'), { elapse: true })
    .on('update.countdown', function(e) {
      if (e.elapsed) {
        productShipMessage = 'Refresh page for updated shipping timer';
        cartShipMessage = 'Refresh page for updated shipping timer';
      } else {
        $('.product-ship-message').html(e.strftime('Order within <strong>%-Ihr %-Mmin</strong>, ships today!'));
        $('.cart-ship-message').text(e.strftime(cartShipMessage));
      }
    });
  }
  $('.product-ship-message').text(productShipMessage);
  $('.cart-ship-message').text(cartShipMessage);

  $('.reorder-checkbox').on('change', function() {
    var variants = [];
    var selected = false;
    $('#reorder-btn').attr('href', '#');
    $('.reorder-checkbox').each(function() {
      if ($(this).prop('checked')) {
        variants.push($(this).val());
        $('#reorder-btn').attr('href', '/cart/' + variants.join());
        selected = true;
      }
      if (selected) {
        $('#reorder-btn').removeClass('disabled');
      } else {
        $('#reorder-btn').addClass('disabled');
      }
    });
  });

  $('#customer_orders .order-row').on('click', function() {
    window.location.href = $(this).find('a').attr('href');
  });

  function resizeIframeHeight () {
    var browserEventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventListener = window[browserEventMethod];
    var eventMessage = browserEventMethod == "attachEvent" ? "onmessage" : "message";
      eventListener(eventMessage, function (e) {
      if (e.data === parseInt(e.data)) {
        document.getElementById('qualifiers-iframe-id').height = e.data + "px";
      }
    });
  }

  resizeIframeHeight();

  //events for setting the same value to quantity inputs on product page
  var qtyField = $('#quantity');
  var qtyFieldSticky = $('#quantity-sticky');
  $(qtyField).on('keyup', function() {
    var value = $(this).val();
    $(qtyFieldSticky).val(value);
  });
  $(qtyFieldSticky).on('keyup', function() {
    var value = $(this).val();
    $(qtyField).val(value);
  });

  //event for synching search fields
  var searchFields = $('input.searchspring-query');
  $(searchFields).on('keyup', function() {
    var value = $(this).val();
    $(searchFields).val(value);
  });

  //switch images in related products section
  $('.collection-image').hover(function() {
    var temp_src = $(this).attr("src");
    $(this).attr("src", $(this).attr("data-alt-src"));
    $(this).attr("data-alt-src", temp_src);
  }, function() {
    var temp_src = $(this).attr("src");
    $(this).attr("src", $(this).attr("data-alt-src"));
    $(this).attr("data-alt-src", temp_src);
  });

  //functionality for SKU select
  function getAllProducts() {
    var limit = 250;
    var productsTotal = 0;
    var url = window.location.origin + '/products.json?limit=' + limit;
    var allProducts = [];

    function getProductsPerPages(count, pagesQty) {
      $.when($.get(url + '&page=' + count + '&req=' + $.now()))
        .then(function(products) {
          allProducts = allProducts.concat(products.products);
          if (count < pagesQty) {
            getProductsPerPages(++count, pagesQty);
          } else {
            store.set('_cns', allProducts);
          }
        }
      );
    }

    $.when($.get(window.location.origin + '/admin/products/count.json'))
      .then(function(dataCount) {
        productsTotal = +dataCount.count;
        if (productsTotal <= limit) {
          url += '&page=1&req=' + $.now();
          $.get(url).done(function(dataProds) {
            store.set('_cns', dataProds.products);
          });
        } else {
          var pages = 0;
          if (productsTotal % limit === 0) {
            pages = productsTotal / limit;
          } else {
            pages = Math.floor(productsTotal / limit) + 1;
          }
          var count = 1;
          getProductsPerPages(count, pages);
        }
      });

  }

  

  function fillSkuSelect() {
    if (store !== undefined) {
      var selectData = store.get('_cns');
      var data = [];
      $.map(selectData, function (obj, i) {
        data[i] = {
          'text': selectData[i].title,
          'children': [
          ]
        };
        selectData[i].variants.forEach(function(element, index) {
          data[i].children.push({
            'id': selectData[i].variants[index].id,
            'text': selectData[i].variants[index].sku + ' - ' + selectData[i].title + ': ' + selectData[i].variants[index].title
          });
        });
      });
      return data;
    }
  }

  
    var cartItemStr = [
      '<tr class="cart-item" data-variant-id="">',
        '<td class="col-sm-2 hidden-xs">',
          '<a href="" class="prod-link">',//link to product (with variant id)
            '<img src="" class="product-image">',//image src link
          '</a>',
        '</td>',
        '<td class="prod-info">',
          '<h2 class="h4 product-title">',
            '<a href="" class="title-link prod-link" data-product-title>',////link to product (with variant id)
            //product title here
            '</a>',
          '</h2>',
          '<h3 class="h5 variant-title" data-variant-title>',/*variant title here*/'</h3>',
          '<p class="part-number"> Part Number ','<span class="sku-number" data-sku-number></span>',/*part number here*/'</p>',
          '<p class="stock">','<span class="inventory-qty" data-inventory-qty></span> in stock, ',// text here e.g.: "51 in stock,"
            '<span class="countdown cart-ship-message">',/*text here e.g.: "ships Monday!"*/'</span>',
          '</p>',
          '<a class="specs small toggle-spec-btn" role="button" data-toggle="collapse" href="" aria-expanded="false" aria-controls="">',
            'Technical specifications',
            '<span class="caret"></span>',
          '</a>',
          '<div class="collapse collapse-table" id="">',
            '<table class="table table-bordered table-specs small">',
              '<tbody id="spec-tbody">',
              '</tbody>',
            '</table>',
          '</div>',
        '</td>',
        '<td class="visible-xs nbsp">&nbsp;</td>',
        '<td class="text-center">',
          '<span class="money" data-currency-usd="$72.00 USD" data-currency="USD">',//to append data attributes values here
            '<span class="price"> USD</span>',/*price e.g. HK$72.00*/
          '</span>',
        '</td>',
        '<td class="text-center col-xs-1">',
          '<input type="number" class="qty form-control" name="updates[]" id="updates_" value="1" pattern="\d*" min="0">',
          //to append atrributes values in input
          '<a class="remove text-muted" href="#" onclick="remove_item(); return false;">Remove</a>',//to apend id in onclick fn
        '</td>',
      '</tr>'
    ].join('');
    

  function getProductDataById(id, variantId) {
    $.when($.get(window.location.origin + '/admin/products/' + id + '.json'))
      .then(function(data) {
        var productLink = 'products/' + data.product.handle + '?variant=' + variantId;
        $('#cart-items-tbody tr:nth-child(2) [data-product-title]').html(data.product.title);
        $('#cart-items-tbody tr:nth-child(2) .prod-link').attr('href', productLink);
        $('#cart-items-tbody tr:nth-child(2) .product-image').attr('src', data.product.images[data.product.images.length - 1].src);
      });
  }

	function getMetafieldsByVariantId(prodId, varId) {
		$.when($.getJSON(window.location.origin + '/admin/products/' + prodId + '/variants/' + varId + '/metafields.json'))
      .then(function(data) {
        var specsStr = '';
        var metadata = data.metafields;
        metadata.forEach(function(item) {
          if (item.hasOwnProperty('namespace') && item['namespace'] === 'specs') {
            var specsKey = item['key'].replace(/_/i, " ");
            specsStr += '<tr><th width="35%">' + specsKey + '</th><td>' + item['value'] + '</td></tr>';
          }
        });
        $('#cart-items-tbody tr:nth-child(2) #spec-tbody').html(specsStr);
      });
  }

  function getProductDataByVariantId(variantId) {
    $.when($.get(window.location.origin + '/admin/variants/' + variantId + '.json'))
      .then(function(data) {
        var variantPrice = data.variant.price;
        if (window.wsVariantsPrice && window.wsVariantsPrice[variant.id]) {
          variantPrice = window.wsVariantsPrice[variant.id]
        }

        $('#cart-items-tbody tr:nth-child(2)').attr('data-variant-id', variantId);
        //console.log(data.variant.title);
        //console.log($('#cart-items-tbody tr:nth-child(2) [data-product-title]').html());
        //console.log(data.variant.title != $('#cart-items-tbody tr:nth-child(2) [data-product-title]').html());
        //if (data.variant.title != $('#cart-items-tbody tr:nth-child(2) [data-product-title]').html()) {
        $('#cart-items-tbody tr:nth-child(2) [data-variant-title]').text($('#cart-items-tbody tr:nth-child(2) [data-variant-title]').text() + data.variant.title);
        //}
        $('#cart-items-tbody tr:nth-child(2) [data-inventory-qty]').html(data.variant.inventory_quantity < 0 ? 0 : data.variant.inventory_quantity);
        $('#cart-items-tbody tr:nth-child(2) .price').html(Shopify.formatMoney(variantPrice, '${{ amount }}') + ' ' + Shopify.currency.active);
        $('#cart-items-tbody tr:nth-child(2) .money').attr('data-currency-' + Shopify.currency.active.toLowerCase(), Shopify.formatMoney(variantPrice, '${{ amount }}') + ' ' + Shopify.currency.active);
        $('#cart-items-tbody tr:nth-child(2) [data-sku-number]').html(data.variant.sku);
        $('#cart-items-tbody tr:nth-child(2) .length-option').html(data.variant.option1);
        $('#cart-items-tbody tr:nth-child(2) .qty.form-control').attr({
          'name': 'updates[' + data.variant.id + ']',
          'id': 'updates_' + data.variant.id
        });
        $('#cart-items-tbody tr:nth-child(2) .remove').attr('onclick', 'remove_item(' + variantId + '); return false;');
        $('.prod-info').each(function(index) {
          var idIndex = index + 1;
          $(this).find('.toggle-spec-btn').attr({
            'href': '#productSpecs' + idIndex,
            'aria-controls': 'productSpecs' + idIndex
          });
          $(this).find('.collapse-table').attr('id', 'productSpecs' + idIndex);
        });
        getProductDataById(data.variant.product_id, variantId);
        getMetafieldsByVariantId(data.variant.product_id, variantId);
      });
  }

  function updateCartTotal() {
    $.when($.getJSON(window.location.origin + '/cart.js'))
      .then(function(data) {
        $('#sub-total, #cart-total').html(Shopify.formatMoney(data.total_price, '${{ amount }}') + ' ' + Shopify.currency.active);
        $('#subtotalCount').html(data.item_count);
      });
  }

  function updateCart(id) {
    var productsIdArray = [];
    $('.cart-item').each(function() {
      productsIdArray.push(+$(this).attr('data-variant-id'));
    });
    var isItemInCart = false;
    var prodIndex = 2;
    var existingValue = 1;
    for (var i = 0; i < productsIdArray.length; i++) {
      if (+id === productsIdArray[i]) {
        isItemInCart = true;
        prodIndex += i;
        break;
      }
    }
    if (!isItemInCart) {
      $('#cart-items-tbody > tr:first-child').after(cartItemStr);
      getProductDataByVariantId(id, prodIndex);
    } else {
      existingValue = +$('#cart-items-tbody tr:nth-child(' + prodIndex + ') .qty.form-control').val();
      $('#cart-items-tbody tr:nth-child(' + prodIndex + ') .qty.form-control').val(++existingValue);
    }
    productsIdArray = [];
  }

  if ($('#sku-select').length > -1) {
    $('#sku-select').select2({
      placeholder: "Quick-search and add a product",
      width: 'resolve',
      data: fillSkuSelect()
    });
  }

  $('#sku-select').on('select2:select', function(e) {
    var data = e.params.data;
    var nonEmptyWrapper = $('#not-empty-cart-wrapper');
    $(this).siblings('input#variant-id').val(data.id);
    $(this).parent('#product-form').submit();

    window.startSkuUpdating = function () {
      if (nonEmptyWrapper.css('display') === 'none') {
        nonEmptyWrapper.show();
        $('#empty-cart-wrapper').hide();
      }
      updateCart(data.id);
      updateCartTotal();
    };
  });

});

function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
var preloadProductImages = function(){
  var $thumbs = $('[data-main-image]');
  if($thumbs.length > 0){
    $thumbs.each(function(){
      var image = new Image();
      image.src = $(this).attr('data-main-image');
    });
  }
};

/* Carousel control heights */
var carouselControlHeight = function () {
  var imgHeight = $('.carousel').find('.item.active img').height();
  $('.carousel-control').css({maxHeight: imgHeight});
};

var getSizedImage = function (imgSrc) {
  var imgSize = Shopify.Image.imageSize(imgSrc);
  return Shopify.Image.getSizedImageUrl(imgSrc.replace('_'+imgSize, ''), '2048x2048');
};

var productImageZoom = function ($imageWrapper) {
  if(Shopify.settings.enable_image_zoom){
    var $productImage = $imageWrapper || $('.product-main-image');
    $productImage.each(function(){
      var $this = $(this);
      var imgSrc = $this.find('img')[0].src;
      var SizedImgSrcLrg = getSizedImage(imgSrc);
      $this.trigger('zoom.destroy');
      $this.zoom({url: SizedImgSrcLrg});
    });
  }
};

/* Product Image Switcher */
var switchImage = function ($imageWrapper, newImageSrc) {
  var $mainImage = $imageWrapper.find('img');
  if($mainImage.attr('src') !== newImageSrc){
    $mainImage.hide().attr('src', newImageSrc).fadeIn();
    productImageZoom($imageWrapper);
  }
};

$(document).on('click', '[data-main-image]', function(event) {
  var $mainImageWrapper = $(this).closest('.product-images').find('.product-main-image');
  var targetImageSrc = $(this).attr('data-main-image');
  switchImage($mainImageWrapper, targetImageSrc);
  event.preventDefault();
});

/* window events */
$(window).load(function(){
  preloadProductImages();
  
  carouselControlHeight();
  var $carousel = $('.carousel');
  if($carousel.find('.item').length > 0){
    $carousel.on('slid.bs.carousel', function(){
      carouselControlHeight();
    });
    $carousel.on('slide.bs.carousel', function(e){
      var currentSlideID = e.relatedTarget.id;
      $(this).attr('data-current-slide', currentSlideID);
    });
  }
  
  productImageZoom();
});

$(window).on('resize', function(){
  carouselControlHeight();
});
/* Facebook gallery via https://gist.github.com/alexdunae/1239554 */

(function(){
  var title = $('#facebook-title'),
  link = $('#facebook-link'),
  viewer = $('#facebook-viewer'),
  thumbs = $('#facebook-thumbs'),
  gallery_id = thumbs.attr('data-album');
  
  if(thumbs.length > 0){
    // album info
    $.getJSON('//graph.facebook.com/' + gallery_id + '?callback=?', function(json) {
      title.html('<a href="' + json.link + '" title="View album on Facebook" target="_blank">' + json.name + '</a>');
      link.html('<i class="fa fa-fw fa-facebook-square text-muted"></i> <a href="' + json.link + '" title="View album on Facebook" target="_blank">View album on Facebook</a>');
    });

    // images
    $.getJSON('//graph.facebook.com/' + gallery_id + '/photos?callback=?', function(json) {
      var imgs = json.data;

      viewer.attr('src', imgs[0].images[0].source);

      for (var i = 0, l = imgs.length - 1; i < l; i++) {
        $('<div class="col-sm-3"><img class="thumbnail" src="' + imgs[i].images[2].source + '" data-fullsize="' + imgs[i].images[0].source + '"></div>').appendTo(thumbs);
      }

      $('img', thumbs).bind('click', function(e) {
        e.preventDefault();
        viewer.attr('src', $(this).attr('data-fullsize'));
      });
    });
  }
}());
/* Recover password form */

function getID(id){ // http://jsperf.com/getelementbyid-vs-jquery-id/44
  return jQuery(document.getElementById(id));
}

var recoverForm = getID('customer-recover-password-form'),
loginForm = getID('customer-login-form');

function showRecoverPasswordForm() {
  recoverForm.parent().show();
  loginForm.parent().hide();
}

function hideRecoverPasswordForm() {
  recoverForm.parent().hide();
  loginForm.parent().show();
}

$('.hide-recover-password-form').on('click', function(e){
  hideRecoverPasswordForm();
  e.preventDefault();
});

$('.show-recover-password-form').on('click', function(e){
  showRecoverPasswordForm();
  e.preventDefault();
});

// dont show links if we dont have both includes present
if(recoverForm === null){ getID('forgotten-password-link').style.display='none'; }
if(loginForm === null){ getID('recover-password-link').style.display='none'; }

hideRecoverPasswordForm();
if (window.location.hash === '#recover') { showRecoverPasswordForm(); }
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return void 0!==t},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){return(Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e)+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return e[o]==undefined?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){o["option"+(r+1)]!=t[r]&&(i=!1)}if(1==i)return void(e=o)}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return void 0===t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(n[1]?r+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_space_separator":r=i(t,2," ",",");break;case"amount_with_period_and_space_separator":r=i(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",");break;case"amount_no_decimals_with_space_separator":r=i(t,0," ");break;case"amount_with_apostrophe_separator":r=i(t,2,"'",".")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0};if(!this.selectVariantFromDropdown(t)){var e=this;setTimeout(function(){e.selectVariantFromParams(t)||e.fireOnChangeForFirstDropdown.call(e,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){this.selectVariantFromParams(t)||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames();return Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e})},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var r=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=r.length-(o?1:0));var n=r.slice(0,a),p=o?r[a]:"",l=(t.getAttribute("value"),{available:!t.disabled,id:parseFloat(t.value),price:p,option1:n[0],option2:n[1],option3:n[2]});s.push(l)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;l<a;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);return null!==e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};